// EditTOC — anchor-based table-of-contents stepper. Mirrors
// design/editRealty.html lines 175-218.
//
// Substrate: .ap-stepper.ap-stepper--toc (canonical modernize.css).
// Each <li class="ap-step"> wraps a button that anchor-jumps to the
// corresponding section. NO scrollspy / IntersectionObserver in R6.1
// per directive STEP R6.1.8 (defer orchestration); the "is-active"
// modifier is omitted entirely — modernize.css renders an inert
// stepper without it.
//
// The button -> anchor jump uses a plain anchor click handler because
// React Router does not intercept hash-only navigation by default.

const TOC_ITEMS = [
  { anchor: "sec-type", icon: "fa-solid fa-tag", label: "Тип і базове" },
  { anchor: "sec-location", icon: "fa-solid fa-location-dot", label: "Локація" },
  { anchor: "sec-specs", icon: "fa-solid fa-list", label: "Характеристики" },
  { anchor: "sec-features", icon: "fa-solid fa-tags", label: "Особливості" },
  { anchor: "sec-media", icon: "fa-solid fa-camera", label: "Фото та медіа" },
  { anchor: "sec-description", icon: "fa-solid fa-pen", label: "Опис" },
  {
    anchor: "sec-manage",
    icon: "fa-solid fa-triangle-exclamation",
    label: "Управління",
  },
];

const scrollToAnchor = (anchor) => {
  if (typeof document === "undefined") return;
  const target = document.getElementById(anchor);
  if (!target) return;
  target.scrollIntoView({ behavior: "smooth", block: "start" });
};

function EditTOC() {
  return (
    <ol
      className="ap-stepper ap-stepper--toc"
      role="list"
      aria-label="Розділи редагування"
    >
      {TOC_ITEMS.map((item) => (
        <li key={item.anchor} className="ap-step" data-anchor={`#${item.anchor}`}>
          <button
            type="button"
            className="ap-step__btn"
            onClick={() => scrollToAnchor(item.anchor)}
          >
            <span className="ap-step__num">
              <i className={item.icon} aria-hidden="true" />
            </span>
            <span className="ap-step__label">{item.label}</span>
          </button>
        </li>
      ))}
    </ol>
  );
}

export default EditTOC;
